module.exports = __webpack_public_path__ + "static/media/exclamation-mark-red.52e7a155.svg";